export class TimesheetReportDto {
  listEmp: any[];
  startDate: string;
  endDate: string;
}

export class RequestTimesheetSearchDto {
  search: string;
}

export class RequestTimesheetRecordEmailDto {
  listEmp: any[];
  startDate: string;
  endDate: string;
  email: string;
  fullName: string;
  search: null;
}

export class ResponseReportSendEmailDto {
  message: string;
  data?: any;
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/timesheet-report.dto.ts